module.exports = __webpack_public_path__ + "static/media/map.d5576619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/map.svg
// module id = 567
// module chunks = 0